import { Link } from 'react-router-dom';
import { Filters } from './filters';

export const Actions = ({ filterText, onFilter }) => (
  <div className="items-toolbar">
    <div className="items-toolbar__actions">
      <Filters filterText={filterText} onFilter={onFilter} />

      <Link to="/payments/items/add">
        <button
          type="button"
          className="btn btn-primary btn-sm items-toolbar__add-btn"
        >
          <span>Novo produto</span>
          <i className="flaticon2-plus"></i>
        </button>
      </Link>
    </div>
  </div>
);
